/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="arrow_right" size=32 />
 */
const StopWatch = () => (
	<>
		<path
			d="M23.5519 16.1693C23.5519 22.2813 18.4946 27.2361 12.256 27.2361C6.01744 27.2361 0.960083 22.2813 0.960083 16.1693C0.960083 10.0572 6.01744 5.10242 12.256 5.10242C18.4946 5.10242 23.5519 10.0572 23.5519 16.1693Z"
			fill="white"
		/>
		<path
			d="M16.464 4.15465L17.2016 2.70938L19.9214 3.94389L19.737 5.08806L18.9994 5.52465L16.464 4.15465Z"
			fill="white"
		/>
		<path d="M3.8634 3.94389L6.50645 2.70938H6.73694L7.53601 4.15465L4.7393 5.52465L3.8634 3.94389Z" fill="white" />
		<path
			d="M22.6826 20.5544C22.6826 20.5544 22.7812 20.0715 22.8529 19.8959C23.31 18.6842 23.5519 17.3672 23.5519 15.9975C23.5519 9.746 18.2913 4.67984 11.9104 4.67984C11.9104 6.11979 11.8208 15.9975 11.8208 15.9975L22.6916 20.5456L22.6826 20.5544Z"
			fill="#B9DEFA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 5.36468C5.86754 5.36468 0.896191 10.2352 0.896191 16.2433C0.896191 22.2514 5.86754 27.122 12 27.122C18.1325 27.122 23.1038 22.2514 23.1038 16.2433C23.1038 10.2352 18.1325 5.36468 12 5.36468ZM0 16.2433C0 9.7503 5.37258 4.48666 12 4.48666C18.6274 4.48666 24 9.7503 24 16.2433C24 22.7364 18.6274 28 12 28C5.37258 28 0 22.7364 0 16.2433Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9104 4.82031C12.1579 4.82031 12.3585 5.01686 12.3585 5.25932V8.67481C12.3585 8.91727 12.1579 9.11382 11.9104 9.11382C11.6629 9.11382 11.4623 8.91727 11.4623 8.67481V5.25932C11.4623 5.01686 11.6629 4.82031 11.9104 4.82031Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.1591 8.16302C20.3337 8.33478 20.3332 8.61274 20.1579 8.78387L17.6844 11.1984C17.5091 11.3696 17.2254 11.3691 17.0507 11.1973C16.876 11.0255 16.8766 10.7476 17.0519 10.5764L19.5254 8.16189C19.7007 7.99076 19.9844 7.99127 20.1591 8.16302Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.1875 16.2433C19.1875 16.0009 19.3881 15.8043 19.6356 15.8043H23.1218C23.3693 15.8043 23.5699 16.0009 23.5699 16.2433C23.5699 16.4858 23.3693 16.6823 23.1218 16.6823H19.6356C19.3881 16.6823 19.1875 16.4858 19.1875 16.2433Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.0507 21.2894C17.2254 21.1176 17.5091 21.1171 17.6844 21.2883L20.1579 23.7028C20.3332 23.8739 20.3337 24.1519 20.1591 24.3237C19.9844 24.4954 19.7007 24.4959 19.5254 24.3248L17.0519 21.9102C16.8766 21.7391 16.876 21.4611 17.0507 21.2894Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9104 23.3816C12.1579 23.3816 12.3585 23.5782 12.3585 23.8206V27.2361C12.3585 27.4786 12.1579 27.6751 11.9104 27.6751C11.6629 27.6751 11.4623 27.4786 11.4623 27.2361V23.8206C11.4623 23.5782 11.6629 23.3816 11.9104 23.3816Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.76048 21.2888C6.93547 21.4603 6.93547 21.7382 6.76048 21.9097L4.29595 24.3242C4.12096 24.4957 3.83724 24.4957 3.66225 24.3242C3.48726 24.1528 3.48726 23.8748 3.66225 23.7034L6.12678 21.2888C6.30177 21.1174 6.58549 21.1174 6.76048 21.2888Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.241943 16.2433C0.241943 16.0009 0.442563 15.8043 0.690039 15.8043H4.17622C4.4237 15.8043 4.62432 16.0009 4.62432 16.2433C4.62432 16.4858 4.4237 16.6823 4.17622 16.6823H0.690039C0.442563 16.6823 0.241943 16.4858 0.241943 16.2433Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.66225 8.16246C3.83724 7.99101 4.12096 7.99101 4.29595 8.16246L6.76048 10.577C6.93547 10.7485 6.93547 11.0264 6.76048 11.1979C6.58549 11.3693 6.30177 11.3693 6.12678 11.1979L3.66225 8.78331C3.48726 8.61187 3.48726 8.3339 3.66225 8.16246Z"
			fill="#002855"
		/>
		<path
			d="M11.5788 17.0774C10.9515 16.7965 10.6647 16.0677 10.9515 15.4443C11.2382 14.8209 11.9821 14.5487 12.6184 14.8297C13.0934 15.0404 15.7282 16.2872 19.1516 18.4208C20.2987 19.132 21.0963 19.5096 20.935 19.8432C20.7737 20.1768 19.9761 19.8432 18.7035 19.4656C14.814 18.3506 12.0448 17.2706 11.5698 17.0599L11.5788 17.0774Z"
			fill="#002855"
		/>
		<path
			d="M13.2368 0.439026H10.9246C10.197 0.439026 9.60718 1.01689 9.60718 1.72971V2.2214C9.60718 2.93423 10.197 3.51209 10.9246 3.51209H13.2368C13.9643 3.51209 14.5542 2.93423 14.5542 2.2214V1.72971C14.5542 1.01689 13.9643 0.439026 13.2368 0.439026Z"
			fill="#B9DEFA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.9246 0.878018C10.4444 0.878018 10.0552 1.25933 10.0552 1.7297V2.22139C10.0552 2.69175 10.4444 3.07306 10.9246 3.07306H13.2367C13.7168 3.07306 14.106 2.69175 14.106 2.22139V1.7297C14.106 1.25933 13.7168 0.878018 13.2367 0.878018H10.9246ZM9.15906 1.7297C9.15906 0.774411 9.9495 0 10.9246 0H13.2367C14.2118 0 15.0022 0.774412 15.0022 1.7297V2.22139C15.0022 3.17667 14.2118 3.95108 13.2367 3.95108H10.9246C9.9495 3.95108 9.15906 3.17667 9.15906 2.22139V1.7297Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.69882 3.94536C4.4406 4.06826 4.33296 4.37296 4.4584 4.62594L4.54455 4.79969C4.66999 5.05267 4.98101 5.15813 5.23922 5.03523L6.69828 4.34081C6.95649 4.21792 7.06413 3.91321 6.93869 3.66023L6.85254 3.48648C6.7271 3.2335 6.41609 3.12805 6.15787 3.25094L4.69882 3.94536ZM3.6523 5.0096C3.31058 4.32045 3.6038 3.49038 4.30722 3.1556L5.76627 2.46118C6.46969 2.1264 7.31694 2.41367 7.65865 3.10282L7.7448 3.27657C8.08651 3.96572 7.79329 4.79579 7.08988 5.13057L5.63082 5.82499C4.9274 6.15978 4.08016 5.8725 3.73845 5.18335L3.6523 5.0096Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.6623 5.04212C18.9194 5.16713 19.2313 5.06423 19.3589 4.81229L19.4466 4.63926C19.5742 4.38731 19.4691 4.08173 19.212 3.95672L17.7589 3.25035C17.5017 3.12534 17.1898 3.22824 17.0622 3.48018L16.9746 3.65322C16.847 3.90516 16.952 4.21074 17.2092 4.33575L18.6623 5.04212ZM20.1617 5.20255C19.8141 5.88888 18.9645 6.16919 18.2639 5.82864L16.8109 5.12227C16.1103 4.78172 15.8242 3.94928 16.1718 3.26296L16.2594 3.08992C16.607 2.4036 17.4567 2.12329 18.1572 2.46383L19.6103 3.1702C20.3108 3.51075 20.597 4.34319 20.2494 5.02952L20.1617 5.20255Z"
			fill="#002855"
		/>
	</>
);

export default StopWatch;
